// extracted by mini-css-extract-plugin
module.exports = {"modal_block":"ReviewAbsenceModal_modal_block__3WQuq","footer":"ReviewAbsenceModal_footer__MA9Rv"};